module.exports = __webpack_public_path__ + "fonts/deal.svg";